import React from "react";
import type { File } from "react-pdf/dist/cjs/shared/types";
import { ServiceContext } from "@app/provider";

type UsePdfFileProps = {
  url: string;
};

type UsePdfFileController = {
  file: File | null;
  pdfTokenError: boolean;
};

const usePdfFile = ({ url }: UsePdfFileProps): UsePdfFileController => {
  const { sessionService } = React.useContext(ServiceContext);
  const [token, setToken] = React.useState<string>("");
  const [pdfTokenError, setPdfTokenError] = React.useState<boolean>(false);

  React.useEffect(() => {
    sessionService
      .getToken()
      .then((authToken) => {
        if (authToken) {
          setToken(authToken.accessToken);
        }
      })
      .catch(() => setPdfTokenError(true));
  }, [url]);

  const file = React.useMemo(() => {
    if (!url) {
      return null;
    }
    if (!token) {
      return null;
    }
    return {
      url,
      httpHeaders: {
        Authorization: `Bearer ${token}`,
      },
    };
  }, [url, token]);

  return { file, pdfTokenError };
};

export default usePdfFile;
